import React from 'react';

function parseBold(line) {
  const parts = line.split(/\*\*(.+?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? <strong key={i}>{part}</strong> : part
  );
}

export default function TrainingTextSection({ section }) {
  const body = section?.textContent?.body || '';
  const image = section?.textContent?.image || '';

  if (!body && !image) return <div className="text-muted fst-italic">Sin contenido.</div>;

  const textBlock = body ? (
    <div className="tts-body" style={{ lineHeight: '1.7', fontSize: '1rem', textAlign: 'start' }}>
      {body.split('\n').map((line, i, arr) => (
        <p key={i} style={{ margin: i < arr.length - 1 ? '0 0 0.5em' : 0 }}>
          {parseBold(line)}
        </p>
      ))}
    </div>
  ) : null;

  if (!image) return <div style={{ width: '100%' }}>{textBlock}</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', width: '100%' }}>
      {textBlock && (
        <div style={{ width: '100%' }}>
        <span>{textBlock}</span>  
        </div>
      )}
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <img
          src={image}
          alt=""
          style={{
            maxWidth: '70%',
            width: 'auto',
            height: 'auto',
            maxHeight: '480px',
            borderRadius: 10,
            objectFit: 'contain',
            display: 'block',
          }}
        />
      </div>
    </div>
  );
}
